import { format as d3Format } from 'd3';

import { FormatType, getFormatter } from '@revelio/replots';

const formatHeadcount = getFormatter(FormatType.SI);
const formatSharePlain = getFormatter(FormatType.PERCENTAGE);
const formatShareDetailed = d3Format('.2~%');

const formatShare = (share: number): string => {
  const text = formatSharePlain(share);
  return text === '0%' && share > 0 ? formatShareDetailed(share) : text;
};

export const formatIcicleHeadcount = (value: number): string =>
  formatHeadcount(value);

export const formatIcicleTooltipValue = (
  value: number,
  baseline: number
): string =>
  baseline > 0
    ? `${formatHeadcount(value)}  /  ${formatShare(value / baseline)}`
    : formatHeadcount(value);

export const formatIcicleShare = (share: number): string => formatShare(share);
